import { AlertSpg, FormSection, GridContainer, GridItem, TextareaFormField } from "@duosoftbg/nacid-components";
import React from "react";
import { useTranslation } from "react-i18next";

const AdditionalInfoFormSection = () => {
  const { t } = useTranslation();

  return (
    <FormSection label={"t.additional.info"}>
      <GridContainer spacing={3} mt={0}>
        <GridItem sm={12} md={12}>
          <AlertSpg severity={"info"}>{t("m.additional.info.section")}</AlertSpg>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <TextareaFormField required={false} fieldName={"additionalInfo"} labelCode={"l.additionalInfo"} />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};

export default AdditionalInfoFormSection;
